const realGame = {
  // 盒子有版号的游戏列表分页
  gameList: '/authApi/box/v1/getVersionGames'
};

export default realGame;
